import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class ActivityLogServices {
    getActivityLog = async (entityId,entityName, page, limit, orgId,subEntityId) => {
      let url = `${Constants.ACTIVITY_LOG}?`;
      if (entityId) url += `entity_id=${entityId}&`;
      if (entityName) url += `entity_name=${entityName}&`;
      if (limit) url += `limit=${limit}&`;
      if (page) url += `page=${page}&`;
      if (orgId) url += `org_id=${orgId}&`;
      if (subEntityId) url += `sub_entity_id=${subEntityId}&`;

      const logs = await Helpers.get({ url });
      return logs;
    }

    /**
     *
     * @param payload
     * @returns {Promise<*>}
     */
    addActivityLog = async (payload) => {
      const logs = await Helpers.post({
        url: Constants.ACTIVITY_LOG,
        data: payload,
      });
      return logs;
    }

    editActivityLog = async (payload) => {
      const message = await Helpers.put({
        url: Constants.UPDATE_ACTIVITY_LOG_MESSAGE,
        data: payload,
      });
      return message;
    }

    getHistoryActivityLog = async (payload) => {
      const message = await Helpers.post({
        url: Constants.GET_HISTORY_LOG_MESSAGE,
        data: payload,
      });
      return message;
    }
}
export default new ActivityLogServices();
